var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhitegem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.52563 3.92739L8.94066 3.05176e-05L11.0514 3.92739H5.52563Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52562 3.92739L2.1106 3.05176e-05H8.94096L5.52593 3.92739H5.52562Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52563 3.92737H11.0514L5.52563 10.5107V3.92737Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52572 3.92736H0L2.11069 0L5.52572 3.92736Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52572 10.5107L0 3.92737H5.52572V10.5107Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_164_4944",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 11
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52563 3.92739L8.94066 3.05176e-05L11.0514 3.92739H5.52563Z",
    fill: "#ED1C24"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52562 3.92739L2.1106 3.05176e-05H8.94096L5.52593 3.92739H5.52562Z",
    fill: "#FF7676"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52563 3.92737H11.0514L5.52563 10.5107V3.92737Z",
    fill: "#AD1515"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52572 3.92736H0L2.11069 0L5.52572 3.92736Z",
    fill: "#EA292C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52572 10.5107L0 3.92737H5.52572V10.5107Z",
    fill: "#D5241C"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_164_4944)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9733 2.6972L0.733073 6.16719L0.0109863 4.03604L10.2512 0.566055L10.9733 2.6972Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7956 4.25038L0.0969367 8.55359L-0.311279 7.34848L12.3874 3.04527L12.7956 4.25038Z",
    fill: "white"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M8.2172 2.35682C7.56046 2.35682 7.02828 2.88899 7.02828 3.54574C7.02828 2.88899 6.4961 2.35682 5.83936 2.35682C6.4961 2.35682 7.02828 1.82464 7.02828 1.16789C7.02828 1.82464 7.56046 2.35682 8.2172 2.35682Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitegem);
export default __webpack_public_path__ + "static/media/whitegem.4bc98b5a7119e3a94d24165ae2aa9336.svg";
export { ForwardRef as ReactComponent };